import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSeoPayload } from "../lib/seo";

const upsertMeta = (selector, attributes) => {
  let node = document.head.querySelector(selector);

  if (!node) {
    node = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) => {
      if (key !== "content") {
        node.setAttribute(key, value);
      }
    });
    document.head.appendChild(node);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    node.setAttribute(key, value);
  });
};

const upsertLink = (selector, attributes) => {
  let node = document.head.querySelector(selector);

  if (!node) {
    node = document.createElement("link");
    document.head.appendChild(node);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    node.setAttribute(key, value);
  });
};

export const SeoManager = ({ data, locale }) => {
  const location = useLocation();

  useEffect(() => {
    const payload = getSeoPayload({ pathname: location.pathname, locale, data });

    document.title = payload.title;
    document.documentElement.lang = payload.htmlLang;

    upsertMeta('meta[name="description"]', { name: "description", content: payload.description });
    upsertMeta('meta[name="keywords"]', { name: "keywords", content: payload.keywords });
    upsertMeta('meta[name="robots"]', { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" });
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: payload.title });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: payload.description });
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: payload.type });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: payload.canonical });
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name", content: "Arista + Vértice" });
    upsertMeta('meta[property="og:locale"]', { property: "og:locale", content: payload.ogLocale });
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMeta('meta[name="twitter:site"]', { name: "twitter:site", content: "@aristamasvertice" });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: payload.title });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: payload.description });

    if (payload.image) {
      upsertMeta('meta[property="og:image"]', { property: "og:image", content: payload.image });
      upsertMeta('meta[property="og:image:alt"]', { property: "og:image:alt", content: payload.title });
      upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: payload.image });
    }

    upsertLink('link[rel="canonical"]', { rel: "canonical", href: payload.canonical });

    document.head.querySelectorAll('link[data-seo-alternate="true"]').forEach((node) => node.remove());

    document.head.querySelectorAll('script[data-seo-schema="true"]').forEach((node) => node.remove());
    payload.schemas.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-schema", "true");
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }, [data, locale, location.pathname]);

  return null;
};
